import Box from "@mui/material/Box";

import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import Typography from "@mui/material/Typography";

import Stack from "@mui/material/Stack";

import Grid from "@mui/material/Grid";

import CachedIcon from "@mui/icons-material/Cached";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { importTransportationPriceListActions } from "../../service/importtransportationpricelist.actions";
import { ImportTransportationFilterAndSearch } from "./ImportTransportationFilterAndSearch";
import Chip from "@mui/material/Chip";
import FileSaver from "file-saver";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import AgGridCustomTable from "../../../../util/component/AgGridCustomTable";
import {
  ColDef,
  GetRowIdParams,
  GridApi,
  GridOptions,
  IServerSideGetRowsParams,
} from "ag-grid-enterprise";
import "ag-grid-enterprise";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";
import { setSnackbar } from "../../../../util/state/globalAction";
import { snackbarTypes } from "../../../../util/state/globalVariables";
import "./importTransportationStyle.css";
import dayjs from "dayjs";
import Card from "@mui/material/Card";
import { ImportTransportationMainTitle } from "./ImportTransportationMainTitle";
import { useTranslation } from "react-i18next";
import CustomLoader from "../../../../util/component/CustomLoader";
import Ellipsis from "../common/Ellipsis";
import { Button, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { FileTextWithIcon } from "../common/FileTextWithIcon";
import { ContextOperation } from "../../context/OperationContext";
import SectionHeader from "../../../../util/component/SectionHeader";
import AgGridOperationTable from "../common/AgGridOperationTable";

export const ImportTransportationTable = () => {
  const { t } = useTranslation(["operation"]);
  const [loading, setIsLoading] = useState<boolean>(false);
  const [refreshPage, setRefreshPage] = useState<boolean>(false);
  const [gridApi, setGridApi] = useState<any>(null);
  const { dispatchGlobalData } = useContext(GlobalContext);
  const [length, setLength] = useState<number>(0);

  const columnDefs: ColDef[] = [
    {
      field: "supplier",
      headerName: t("importTrasportation.supplier"),
      flex: 1,

      cellRenderer: (cellValues: any) => SupplierColumn(cellValues),
    },
    {
      field: "fileName",
      headerName: t("importTrasportation.fileName"),
      flex: 1.4,

      cellRenderer: (cellValues: any) => PriceFileColumn(cellValues),
    },
    {
      field: "startDate",
      headerName: t("importTrasportation.startDate"),
      flex: 0.9,
      cellRenderer: (cellValues: any) => startDateColumn(cellValues),
    },
    {
      field: "endDate",
      headerName: t("importTrasportation.endDate"),
      flex: 0.9,
      cellRenderer: (cellValues: any) => endDateColumn(cellValues),
    },
    {
      field: "errorFilename",
      headerName: t("importTrasportation.errorFilename"),
      flex: 1.4,
      cellRendererSelector: (cellValues: any) => {
        return {
          component: () => FailReportColumn(cellValues),
        };
      },
    },
    {
      field: "status",
      headerName: t("importTrasportation.status"),
      flex: 1,
      cellRenderer: (cellValues: any) => StatusColumn(cellValues),
    },
  ];
  const [pageSize, setPageSize] = useState<number>(10);

  const [
    dataFormSearchFieldImportTransportation,
    setDataFormSearchFieldImportTransportation,
  ] = useState<any>({
    supplierId: { id: "", descr: "" },
    fileName: "",
    startDateFrom: null,
    startDateTo: null,
    status: "",
  });
  const { tenant, setLoading } = useContext(ContextOperation);
  const handleErrorFileColumnClick = (param: any) => {
    exportErrorFileImportTransportationPriceListDataById(param.data.id);
  };

  const handleFileColumnClick = (param: any) => {
    exportFileImportTransportationPriceListDataById(param.data.id);
  };

  const SupplierColumn = (cellValues: any) => {
    return (
      <Tooltip title={cellValues.data.supplier}>
        <Box component="span" width="inherit" height="inherit">
          {cellValues.data.supplier}
        </Box>
      </Tooltip>
    );
  };
  const startDateColumn = (cellValues: any) => {
    return (
      <>
        {cellValues.data.startDate ? (
          <Box component="span" width="inherit" height="inherit">
            {dayjs(cellValues.data.startDate).format("DD/MM/YYYY-HH:mm")}
          </Box>
        ) : (
          <Box> </Box>
        )}
      </>
    );
  };
  const endDateColumn = (cellValues: any) => {
    return (
      <>
        {cellValues.data.endDate ? (
          <Box width="inherit" height="inherit" component="span">
            {dayjs(`${cellValues.data.endDate}`).format("DD/MM/YYYY-HH:mm")}
          </Box>
        ) : (
          <Box></Box>
        )}
      </>
    );
  };
  const PriceFileColumn = (cellValues: any) => {
    return (
      <FileTextWithIcon
        onDownloadFile={() => {
          handleFileColumnClick(cellValues);
        }}
        fileTextDownload={cellValues.data.fileName}
      ></FileTextWithIcon>
    );
  };
  const FailReportColumn = (cellValues: any) => {
    if (!!cellValues.data.errorFilename) {
      return (
        <FileTextWithIcon
          onDownloadFile={() => {
            handleErrorFileColumnClick(cellValues);
          }}
          fileTextDownload={cellValues.data.errorFilename}
          fileTextColorRed={true}
        />
      );
    } else {
      return cellValues.data.errorFilename;
    }
  };

  const StatusColumn = (cellValues: any) => {
    switch (cellValues.data.status) {
      case "SUCCESS":
        return (
          <Chip
            label={t("internOptionSelectName.statusType.success")}
            variant="filled"
            color="success"
          />
        );
      case "PENDING":
        return (
          <Chip
            label={t("internOptionSelectName.statusType.pending")}
            variant="filled"
            color="warning"
          />
        );
      case "WAITING":
        return (
          <Chip
            label={t("internOptionSelectName.statusType.waiting")}
            variant="filled"
            color="warning"
          />
        );

      case "WITH_ERRORS_XLS_FORMAT":
        return (
          <Chip
            label={t("internOptionSelectName.statusType.xlsError")}
            variant="filled"
            color="error"
          />
        );
      case "WITH_ERRORS_SYNTAX":
        return (
          <Chip
            label={t("internOptionSelectName.statusType.syntaxError")}
            variant="filled"
            color="error"
          />
        );

      case "WITH_ERRORS_DATA_INTEGRITY":
        return (
          <Chip
            label={t("internOptionSelectName.statusType.dataIntegrityError")}
            variant="filled"
            color="error"
          />
        );
      case "WITH_ERRORS_GENERIC_ERROR":
        return (
          <Chip
            label={t("internOptionSelectName.statusType.genericError")}
            variant="filled"
            color="error"
          />
        );
      default:
        return "";
    }
  };

  const exportDataImportTransportationPriceList = async () => {
    setLoading(true);
    let fileName = !!dataFormSearchFieldImportTransportation?.fileName
      ? dataFormSearchFieldImportTransportation?.fileName
      : null;
    let status = !!dataFormSearchFieldImportTransportation?.status
      ? dataFormSearchFieldImportTransportation?.status
      : null;
    let startDateFrom = dayjs(
      dataFormSearchFieldImportTransportation?.startDateFrom
    ).isValid()
      ? dayjs
          .utc(dataFormSearchFieldImportTransportation?.startDateFrom)
          .format("YYYY-MM-DDTHH:mm:ssZ")
      : null;
    let startDateTo = dayjs(
      dataFormSearchFieldImportTransportation?.startDateTo
    ).isValid()
      ? dayjs
          .utc(dataFormSearchFieldImportTransportation?.startDateTo)
          .format("YYYY-MM-DDTHH:mm:ssZ")
      : null;
    let supplierId = dataFormSearchFieldImportTransportation?.supplierId?.id
      ? dataFormSearchFieldImportTransportation?.supplierId?.id
      : null;

    importTransportationPriceListActions()
      .exportDataImportTransportationPriceList(
        tenant,
        fileName,
        status,
        startDateFrom,
        startDateTo,
        supplierId
      )
      .then((response: any) => {
        setLoading(false);
        const filename =
          response.headers["content-disposition"].split("filename=")[1];
        var blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        FileSaver.saveAs(blob, filename);
      });
  };

  const SearchImportTransportation = (dataFormSearch: any) => {
    let fileName = !!dataFormSearch?.fileName ? dataFormSearch?.fileName : null;
    let status = !!dataFormSearch?.status ? dataFormSearch?.status : null;
    let startDateFrom = dayjs(dataFormSearch?.startDateFrom).isValid()
      ? dayjs.utc(dataFormSearch?.startDateFrom).format("YYYY-MM-DDTHH:mm:ssZ")
      : null;
    let startDateTo = dayjs(dataFormSearch?.startDateTo).isValid()
      ? dayjs.utc(dataFormSearch?.startDateTo).format("YYYY-MM-DDTHH:mm:ssZ")
      : null;
    let supplierId = !!dataFormSearch?.supplierId?.id
      ? dataFormSearch?.supplierId?.id
      : null;
    setIsLoading(true);
    return {
      getRows: async (params: IServerSideGetRowsParams) => {
        const startRow = params.request.startRow ? params.request.startRow : 0;
        const endRow = params.request.endRow;
        let pageSize = 10;
        if (
          endRow !== null &&
          endRow !== undefined &&
          startRow !== null &&
          startRow !== undefined
        ) {
          pageSize = endRow - startRow;
        }
        const pageNumber = startRow / pageSize;

        importTransportationPriceListActions()
          .getImportTransportationPriceList(
            tenant,
            pageNumber,
            pageSize,
            fileName,
            status,
            startDateFrom,
            startDateTo,
            supplierId
          )
          .then((response: any) => {
            params.successCallback(
              manageData(response),
              response.data.totalElements
            );
			setLength(response.data.totalElements);

            setIsLoading(false);
          })
          .catch((error) => {
            if (error.response) {
              dispatchGlobalData({
                type: setSnackbar,
                payload: {
                  snackbar: {
                    message: error.response.data.error,
                    type: snackbarTypes.error,
                    show: true,
                    autoClose: true,
                  },
                },
              });
              setIsLoading(false);
            } else if (error.request) {
              dispatchGlobalData({
                type: setSnackbar,
                payload: {
                  snackbar: {
                    message: t("networkErrorMessage"),
                    type: snackbarTypes.error,
                    show: true,
                    autoClose: true,
                  },
                },
              });
              setIsLoading(false);
            } else {
              setIsLoading(false);
            }
          });
      },
    };
  };
  const exportErrorFileImportTransportationPriceListDataById = async (
    id: string
  ) => {
    setIsLoading(true);
    importTransportationPriceListActions()
      .exportErrorImportTransportationPriceListDataById(tenant, id)
      .then((response: any) => {
        setIsLoading(false);
        const filename =
          response.headers["content-disposition"].split("filename=")[1];
        var blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        FileSaver.saveAs(blob, filename);
      });
  };

  const exportFileImportTransportationPriceListDataById = async (
    id: string
  ) => {
    setIsLoading(true);
    importTransportationPriceListActions()
      .exportFileImportTransportationPriceListDataById(tenant, id)
      .then((response: any) => {
        setIsLoading(false);
        const filename =
          response.headers["content-disposition"].split("filename=")[1];
        var blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        FileSaver.saveAs(blob, filename);
      });
  };
  const resetFormTextImportTransportation = () => {
    setDataFormSearchFieldImportTransportation({
      supplierId: { id: "", descr: "" },
      fileName: "",
      startDateFrom: null,
      startDateTo: null,
      status: "",
    });
    setRefreshPage(!refreshPage);
  };

  function manageData(response: any) {
    let rows: any[] = [];
    response.data.content.forEach((element: any) => {
      let row = {
        supplier: element.supplier.descr,
        supplierId: element.supplier.id,
        fileName: element.filename,
        startDate: element.startDatetime,
        endDate: element.endDatetime,
        errorFilename: element.errorFilename,
        absPathErrorFile: element.absPathErrorFile,
        status: element.status,
        id: element.id,
      };

      rows.push(row);
    });

    return rows;
  }

  const onGridReady = (params: any) => {
    setGridApi(params.api);
  };

  useEffect(() => {
    if (gridApi) {
      gridApi.setServerSideDatasource(
        SearchImportTransportation(dataFormSearchFieldImportTransportation)
      );
    }
  }, [gridApi, refreshPage]);

  return (
    <>
      <SectionHeader
        title={
          t("importTrasportation.mainTitle.importTransport") +
          " " +
          t("importTrasportation.mainTitle.priceList")
        }
        subtitle={t("importTrasportation.mainTitle.transportPrice")}
      />
      <ImportTransportationFilterAndSearch
        refreshPage={refreshPage}
        setRefreshPage={setRefreshPage}
        resetFormTextImportTransportation={resetFormTextImportTransportation}
        dataFormSearchFieldImportTransportation={
          dataFormSearchFieldImportTransportation
        }
        setDataFormSearchFieldImportTransportation={
          setDataFormSearchFieldImportTransportation
        }
        tenant={tenant}
      />

      <Box ml={2} mr={2}>
        <Card>
          <Stack
            pr={1}
            spacing={1}
            direction={"row"}
            minHeight={46}
            display="flex"
            justifyContent={"flex-end"}
            alignItems="center"
          >
            <Box>
              <Tooltip title={t("importTrasportation.mainTitle.refreshTable")}>
                <IconButton
                  color="accent"
                  onClick={() => setRefreshPage(!refreshPage)}
                >
                  <CachedIcon sx={{ fontSize: "22px" }} />
                </IconButton>
              </Tooltip>
            </Box>

            <Box>
              <Tooltip title={t("tooltipTitle.download")}>
                <IconButton
                  color="accent"
                  onClick={exportDataImportTransportationPriceList}
                >
                  <FileDownloadIcon />
                </IconButton>
              </Tooltip>
            </Box>
          </Stack>
        </Card>
      </Box>
      <Box pr={2} pl={2}>
        <Box>
          <Box>
		   <AgGridOperationTable

              columnDefs={columnDefs}
              onGridReady={onGridReady}
              cacheBlockSize={pageSize}
              serverSideInfiniteScroll={true}
              rowModelType={"serverSide"}
			  totalElements={length}

            />

          </Box>
        </Box>
      </Box>

      {loading && <CustomLoader loading={loading} />}
    </>
  );
};
